import { motion } from "framer-motion";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import GlobalHeader from "@/components/GlobalHeader";

export default function Kontakt() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/20">
      {/* Global Header */}
      <GlobalHeader />
      
      <div className="container mx-auto px-4 py-12 max-w-4xl pt-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="space-y-8"
        >
          {/* Header */}
          <div className="text-center space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold">Kontakt</h1>
            <p className="text-muted-foreground">
              Wir freuen uns auf Ihre Nachricht!
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Contact Info */}
            <div className="space-y-6">
              <div className="bg-card rounded-2xl p-6 border shadow-sm space-y-6">
                <h2 className="text-2xl font-bold">Kontaktinformationen</h2>
                
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <MapPin className="w-6 h-6 text-primary mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-semibold">Adresse</p>
                      <p className="text-muted-foreground">
                        Nordstormarnstraße 10<br />
                        23858 Wesenberg<br />
                        Deutschland
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <Phone className="w-6 h-6 text-primary mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-semibold">Telefon</p>
                      <a href="tel:045336090371" className="text-muted-foreground hover:text-primary transition-colors">
                        045336090371
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <Mail className="w-6 h-6 text-primary mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-semibold">E-Mail</p>
                      <a href="mailto:info@mokiplaner.com" className="text-muted-foreground hover:text-primary transition-colors">
                        info@mokiplaner.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-primary/10 to-accent/10 rounded-2xl p-6 border border-primary/20">
                <h3 className="font-semibold mb-2">Geschäftszeiten</h3>
                <p className="text-muted-foreground text-sm">
                  Montag - Freitag: 9:00 - 18:00 Uhr<br />
                  Samstag: 10:00 - 14:00 Uhr<br />
                  Sonntag: Geschlossen
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-card rounded-2xl p-6 border shadow-sm">
              <h2 className="text-2xl font-bold mb-6">Senden Sie uns eine Nachricht</h2>
              
              <form className="space-y-4" onSubmit={(e) => {
                e.preventDefault();
                window.location.href = 'mailto:info@mokiplaner.com?subject=' + encodeURIComponent(e.target.subject.value) + '&body=' + encodeURIComponent(e.target.message.value);
              }}>
                <div>
                  <Label htmlFor="name">Name *</Label>
                  <Input 
                    id="name" 
                    name="name"
                    placeholder="Ihr Name" 
                    required
                    className="mt-1"
                  />
                </div>

                <div>
                  <Label htmlFor="email">E-Mail *</Label>
                  <Input 
                    id="email" 
                    name="email"
                    type="email" 
                    placeholder="ihre.email@beispiel.de" 
                    required
                    className="mt-1"
                  />
                </div>

                <div>
                  <Label htmlFor="subject">Betreff *</Label>
                  <Input 
                    id="subject" 
                    name="subject"
                    placeholder="Betreff Ihrer Nachricht" 
                    required
                    className="mt-1"
                  />
                </div>

                <div>
                  <Label htmlFor="message">Nachricht *</Label>
                  <Textarea 
                    id="message" 
                    name="message"
                    placeholder="Ihre Nachricht..." 
                    rows={5}
                    required
                    className="mt-1"
                  />
                </div>

                <Button type="submit" className="w-full rounded-full">
                  <Send className="w-4 h-4 mr-2" />
                  Nachricht senden
                </Button>
              </form>
            </div>
          </div>

          {/* Back Button */}
          <div className="text-center">
            <Link to="/">
              <Button variant="outline" className="rounded-full">
                Zurück zur Startseite
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
